import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
    mCPF,
    getCookie,
    mDate,
    mTel,
    Aguarde,
} from "../../../helpers/general";
import { validateCPF, validateDate } from "../../../helpers/validation";
import { sendData } from "../../../helpers/auth";
import { uriList } from "../../../helpers/config";
import { swalError } from "../../swal";

import moment from "moment";

function DadosComplementaresModal(props) {
    const [clienteExiste, setClienteExiste] = useState(true); //-- Cliente é tratado como true sempre que nao foi validado ainda
    const [_aguarde, setAguarde] = useState(false);

    const [data, setData] = useState({
        nome: "",
        cpf: "",
        sexo: "",
        dataNascimento: "",
    });

    const [warning, setWarning] = useState({
        cpf: false,
        dataNascimento: false,
    });

    // Validação e formatação do CPF e Data de Nascimento
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "cpf") {
            // Formata o CPF usando mCPF
            const cpfFormatado = mCPF(value);
            setData((prev) => ({
                ...prev,
                cpf: cpfFormatado,
            }));
            // Validação de CPF
            const isValid = validateCPF(cpfFormatado);
            setWarning((prev) => ({ ...prev, cpf: !isValid || cpfFormatado.length < 14 }));

            //-- Verifica se é cliente cadastrado
            if (cpfFormatado.length === 14)
                handleCliente(cpfFormatado)
            else
                setClienteExiste(true);
        } else if (name === "dataNascimento") {
            // Formata a data usando mDate
            const dataFormatada = mDate(value);
            setData((prev) => ({
                ...prev,
                dataNascimento: dataFormatada,
            }));
            // Validação: dataFormatada deve ter 10 caracteres (DD/MM/AAAA) e ser válida
            const isValid = validateDate(dataFormatada) && dataFormatada.length === 10;
            setWarning((prev) => ({ ...prev, dataNascimento: !isValid }));
        } else {
            setData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleCliente = async (cpf) => {
        const _cpf = cpf.replace(/\D/g, '');
        console.log("dadosComplementares.handleCliente(0): ", _cpf)
        if (_cpf?.length === 11) {
            setAguarde(true);
            console.log("dadosComplementares.handleCliente(2): ", uriList("pessoa"))
            await sendData({
                uri: uriList("pessoa"),
                content: { cpf },
                signal: null,
                method: "POST",
            })
                .then((res) => {
                    console.log("dadosComplementares.handleCliente - res: ", res.data)
                    if (parseInt(res?.status) > 200) {
                        setClienteExiste(false);
                        return;
                    }

                    setData((prev) => ({
                        ...prev,
                        nome: res.data.nome,
                        sexo: res.data.sexo,
                        dataNascimento: moment(res.data.dataNascimento || res.data.ddn).format("DD/MM/YYYY"),
                    }));
                    setClienteExiste(true);
                    setAguarde(false);
                })
                .catch((e) => {
                    console.log("dadosComplementares.handleCliente - erro: ", e)
                    setClienteExiste(false);
                    setAguarde(false);
                });
            setAguarde(false);
        }
    }

    const handleContinuar = () => {
        //-- Retirar o foco de onde estiver para que os valores sejam atualizados
        const activeElement = document.activeElement;
        if (activeElement) activeElement.blur();

        if (!getValidForm()) {
            swalError("Preencha todos os campos obrigatórios");
            return;
        }

        if (props.onCloseEv) {
            props.onCloseEv(data);
        }
    };

    const handleCancelar = () => {
        if (props.onCloseEv) {
            props.onCloseEv(null);
        }
    };

    const getValidForm = () => {
        const valid = (data.cpf &&
            data.sexo &&
            data.dataNascimento &&
            !warning.cpf &&
            !warning.dataNascimento);
        console.log("getValidForm: ", valid)
        if (!valid) {
            swalError("Preencha todos os campos obrigatórios");
        }
        return valid
    }

    const getValidCpf = () => {
        const cpf = data.cpf.replace(/\D/g, '');
        if (cpf.length === 11) {
            return validateCPF(cpf);
        }
        return false;
    }

    return (
        <>
            {_aguarde && <Aguarde legenda={"Aguarde, validando cliente..."} />}
            <Modal
                show={true}
                onHide={handleCancelar}
                size="sm"
                centered
                backdrop="static"
                animation={false}
            >
                <Modal.Header closeButton className="p-1 ml-3">
                    <Modal.Title className="text-left p-0 text-center" style={{ fontSize: "1.2rem" }}>Dados Complementares</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-3 py-2">
                    <div className="mb-2">
                        <label className="form-label">CPF</label>
                        <input
                            type="text"
                            name="cpf"
                            className={`form-control${warning.cpf ? " is-invalid" : ""}`}
                            value={data.cpf}
                            onChange={handleChange}
                            maxLength={14}
                            autoFocus
                            placeholder="000.000.000-00"
                        />
                        {warning.cpf && (
                            <div className="invalid-feedback" style={{ display: "block" }}>
                                CPF inválido
                            </div>
                        )}
                    </div>
                    {getValidCpf() && !clienteExiste && <>
                        <div className="mb-2">
                            <label className="form-label d-block">Sexo</label>
                            <select
                                name="sexo"
                                className="form-control text-capitalize"
                                value={data.sexo}
                                onChange={handleChange}
                                style={{
                                    borderColor: "", // ajuste se quiser destacar erro
                                    backgroundColor: "#EBEEE9",
                                    borderRadius: "4px",
                                    border: "1.5px solid #727476",
                                    backgroundImage: "linear-gradient(to top, #D1D3D4, #F7F8F9 90%)",
                                }}
                            >
                                <option value="">Selecione</option>
                                <option value="MASCULINO">Masculino</option>
                                <option value="FEMININO">Feminino</option>
                                {/* <option value="OUTROS">Outros</option> */}
                            </select>
                        </div>
                        <div>
                            <label className="form-label">Data de Nascimento</label>
                            <input
                                type="text"
                                name="dataNascimento"
                                className={`form-control${warning.dataNascimento ? " is-invalid" : ""}`}
                                value={data.dataNascimento}
                                onChange={handleChange}
                                maxLength={10}
                                placeholder="DD/MM/AAAA"
                            />
                            {warning.dataNascimento && (
                                <div className="invalid-feedback" style={{ display: "block" }}>
                                    Data inválida
                                </div>
                            )}
                        </div>
                    </>}
                </Modal.Body>
                <Modal.Footer className="py-2 px-3">
                    <Button variant="secondary" onClick={handleCancelar}>
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleContinuar}
                        disabled={_aguarde}
                        style={{ fontWeight: "bold" }}
                    >
                        Continuar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DadosComplementaresModal;
